const values = [
  { icon: 'ri-eye-line', title: '事实先行', desc: '尽量以可查证的一手截图、视频与多方信源交叉核实，模棱两可的信息明确标注存疑，不传未经证实的瓜。' },
  { icon: 'ri-scales-3-line', title: '不站队不抢跑', desc: '我们只做事件的搬运与复盘，不替任何一方站台，也不为了流量抢跑发布未经核实的内容。' },
  { icon: 'ri-archive-2-line', title: '系统化合集', desc: '把散落在各平台的反差名场面与爆点热闻，整理成结构清晰的事件合集，让追瓜有迹可循、不迷路。' },
];

export default function BrandStrip() {
  return (
    <section aria-label="关于反差吃瓜" className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-5">
            <p className="text-xs font-bold uppercase tracking-widest text-accent-600">About Us</p>
            <h3 className="mt-2 text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
              关于「反差吃瓜」<br />
              我们只负责把瓜讲清楚
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              反差吃瓜是一个专注「反差吃瓜事件合集」的内容入口。我们把镜头前与镜头后、人设与真实之间落差最大的名场面和热闻整理成每日可快速读完的速报，让想快速看完当天值得吃的瓜的你，点进来看就够了。
            </p>
            <a
              href="#subscribe"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600"
            >
              加入吃瓜人群
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="flex flex-col gap-4 lg:col-span-7">
            {values.map((v, i) => (
              <div key={v.title} className="flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-accent-100 text-xl text-accent-700">
                  <i className={v.icon} aria-hidden="true"></i>
                </span>
                <div>
                  <h4 className="font-bold text-foreground-900">
                    <span className="mr-2 text-accent-600">{String(i + 1).padStart(2, '0')}</span>
                    {v.title}
                  </h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}